export default __webpack_public_path__ + "static/media/284.50550223.gif";